/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/mv_union.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns all unique values from the combined input fields (set union). Null values are treated as empty sets; returns `null` only if both fields are null.',
  examples: [
    'ROW a = [1, 2, 3, 4, 5], b = [2, 3, 4, 5, 6]\n| EVAL finalValue = MV_UNION(a, b)\n| KEEP finalValue',
    'ROW a = [1, 2, 3, 4, 5]::long, b = [2, 3, 4, 5, 6]::long\n| EVAL finalValue = MV_UNION(a, b)\n| KEEP finalValue',
    'ROW a = [true, false], b = [false]\n| EVAL finalValue = MV_UNION(a, b)\n| KEEP finalValue',
    'ROW a = [5.2, 10.5, 1.12345], b = [10.5, 2.6928]\n| EVAL finalValue = MV_UNION(a, b)\n| KEEP finalValue',
    'ROW a = ["one", "two", "three"], b = ["two", "four"]\n| EVAL finalValue = MV_UNION(a, b)\n| KEEP finalValue',
  ],
  params: {
    field1: 'Expression that can be null, a single value, or multiple values. Null values are treated as empty sets.',
    field2: 'Expression that can be null, a single value, or multiple values. Null values are treated as empty sets.',
  },
};

export default docs;
